import React, { useEffect } from "react";
import {
  Button,
  Col,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { createTicket } from "../../slices/apps/ticketSlice";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// react select
import Select from "react-select";

const categoryOptions = [
  { label: "Teknik Destek", value: "Teknik Destek" },
  { label: "Muhasebe & Finans", value: "Muhasebe & Finans" },
  { label: "Satış Öncesi", value: "Satış Öncesi" },
  { label: "Diğer", value: "Diğer" },
];

const TicketAddModal = ({ modal, setModal }) => {
  const dispatch = useDispatch();

  const { createTicketLoading } = useSelector(
    (state) => ({
      createTicketLoading: state.ticket.createTicketLoading,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (modal) {
      validation.resetForm();
    }
  }, [modal]);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      title: "",
      category: "",
      message: "",
    },

    validationSchema: Yup.object({
      title: Yup.string().required("Lütfen konu başlığı girin"),
      category: Yup.string().required("Lütfen bir kategori seçin"),
      message: Yup.string()
        .required("Lütfen mesajınızı yazın")
        .min(10, "Mesajınız en az 10 karakter olmalıdır"),
    }),

    onSubmit: async (values) => {
      const resultAction = await dispatch(createTicket(values));

      if (resultAction.meta.requestStatus === "fulfilled") {
        setModal(false);
      }
    },
  });

  return (
    <Modal
      size="lg"
      isOpen={modal}
      toggle={() => {
        setModal(false);
      }}
      centered
    >
      <ModalHeader
        className="modal-title"
        toggle={() => {
          setModal(false);
        }}
      >
        Yeni Destek Talebi Oluştur
      </ModalHeader>

      <ModalBody>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
          autoComplete="off"
        >
          <Row>
            <Col lg={12}>
              <div className="mb-3">
                <Label htmlFor="title" className="form-label">
                  Konu Başlığı
                </Label>
                <Input
                  name="title"
                  className="form-control"
                  placeholder="Örn: Çekici hizmeti hakkında"
                  type="text"
                  onChange={validation.handleChange}
                  value={validation.values.title || ""}
                  invalid={
                    validation.touched.title && validation.errors.title
                      ? true
                      : false
                  }
                />
                {validation.touched.title && validation.errors.title && (
                  <FormFeedback type="invalid">
                    {validation.errors.title}
                  </FormFeedback>
                )}
              </div>
            </Col>

            <Col lg={12}>
              <div className="mb-3">
                <Label htmlFor="category" className="form-label">
                  Kategori
                </Label>
                <Select
                  placeholder="Kategori seçiniz"
                  name="category"
                  options={categoryOptions}
                  classNamePrefix="select2-selection"
                  value={
                    categoryOptions.find(
                      (option) => option.value === validation.values.category
                    ) || ""
                  }
                  onChange={(option) => {
                    validation.setFieldValue("category", option.value);
                  }}
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      borderColor:
                        validation.touched.category &&
                        validation.errors.category &&
                        !state.isFocused
                          ? "#e30a17"
                          : baseStyles.borderColor,
                    }),
                  }}
                />
                {validation.touched.category && validation.errors.category && (
                  <div className="d-block invalid-feedback">
                    {validation.errors.category}
                  </div>
                )}
              </div>
            </Col>

            <Col lg={12}>
              <div className="mb-3">
                <Label htmlFor="message" className="form-label">
                  Mesajınız
                </Label>
                <Input
                  name="message"
                  className="form-control"
                  placeholder="Sorununuzu detaylı bir şekilde açıklayınız..."
                  type="textarea"
                  rows="5"
                  onChange={validation.handleChange}
                  value={validation.values.message || ""}
                  invalid={
                    validation.touched.message && validation.errors.message
                      ? true
                      : false
                  }
                  style={{ resize: "none" }}
                />
                {validation.touched.message && validation.errors.message && (
                  <FormFeedback type="invalid">
                    {validation.errors.message}
                  </FormFeedback>
                )}
              </div>
            </Col>
          </Row>

          <div className="d-flex align-items-center gap-3 mt-4">
            <Button
              className="btn btn-sm ms-auto"
              color="primary"
              type="submit"
              disabled={createTicketLoading}
            >
              {createTicketLoading ? (
                <>
                  <Spinner size="sm" className="me-1" /> Gönderiliyor...
                </>
              ) : (
                "Talep Oluştur"
              )}
            </Button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default TicketAddModal;
